import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class AddressPipeService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getCountryByCode(code: string, lang: string): Observable<any> {
    const url = environment.apiCartographerUrl.concat("BuilkAddress/GetCountryNameFromCode");
    const params = new HttpParams()
                  .set("countryCode", code)
                  .set("languageCode", lang);

    return  this.httpClient.get(url, {params, responseType: "text"});

  }

  getProvinceByCode(code: string, lang: string): Observable<any> {
    const url = environment.apiCartographerUrl.concat("BuilkAddress/GetProvinceNameFromCode");
    const params = new HttpParams()
                  .set("provinceCode", code)
                  .set("languageCode", lang);

    return  this.httpClient.get(url, {params, responseType: "text"});

  }
}
